export enum SubscriptionModalType {
    PaymentPermission = "paymentPermission",
    PaymentWithFunds = "paymentWithFunds", 
    UnlockedProgram = "unlockedProgram",
}